import { render, staticRenderFns } from "./subPageFour.vue?vue&type=template&id=281d45b9&scoped=true"
import script from "./subPageFour.vue?vue&type=script&lang=js"
export * from "./subPageFour.vue?vue&type=script&lang=js"
import style0 from "./subPageFour.vue?vue&type=style&index=0&id=281d45b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281d45b9",
  null
  
)

export default component.exports